import gql from 'graphql-tag';

export const newFeedback = gql`
  mutation newFeedback($feedbackInput: FeedbackInput!) {
    newFeedback(feedbackInput: $feedbackInput)
  }
`;
